import { Modal, Button } from 'react-bootstrap'
import AsideModal from '../../Common/AsideModal/AsideModal'
import { useEffect, useState } from 'react'
import axios from 'axios'
import DataTable from 'react-data-table-component';
import accountsHeader from './accountsHeader'
import EditAccount from './EditAccount'
import sweetAlert from 'sweetalert'
import './Accounts.scss'

const Accounts = () => {
  const [data, setData] = useState([])
  const [title, setTitle] = useState('')
  const [active, setActive] = useState(false)
  const [showAsideModal, setShowAsideModal] = useState(false)
  const [showDeleteAccountModal, setShowDeleteAccountModal] = useState(false)
  const [initialAccountFormValue, setInitialAccountFormValue] = useState({
    buyer: '',
    auction: '',
    comment: '',
    password: '',
  })
  const [action, setAction] = useState('edit')

  useEffect(() => {
    axios(process.env.REACT_APP_BASE_URL + '/api/accounts')
      .then(response => {
        const accounts = response.data.data
        setData([...accounts])
      })
      .catch(err => {
        console.log(err)
      })
  }, [])

  const handlers = {
    editAccounts(account) {
      setShowAsideModal(true)
      setActive({ ...account })
      setAction('edit')
      setTitle('Edit Account')
      setInitialAccountFormValue({
        buyer: account.buyer,
        auction: account.auction,
        comment: account.comment,
        password: account.password,
      })
    },
    addAccount() {
      setShowAsideModal(true)
      setTitle('Add account')
      setAction('add')
      setInitialAccountFormValue({ buyer: '', auction: '', comment: '', password: '' })
    },
    deleteAccount(account) {
      setActive({ ...account })
      setShowDeleteAccountModal(true)
    },
    edit(accountFormValue) {
      axios
        .put(`/api/accounts/${active.id}`, accountFormValue)
        .then(() => {
          setShowAsideModal(false)
          const ac = data.map(a => {
            if (a.id === active.id)
              return {
                id: a.id,
                buyer: accountFormValue.buyer,
                auction: accountFormValue.auction,
                comment: accountFormValue.comment,
              }
            return a
          })

          setData([...ac])
        })
        .catch(() => {
          sweetAlert('Error', 'Failed to update account', 'error')
        })
    },
    add(accountFormValue) {
      axios
        .post(`/api/accounts`, accountFormValue)
        .then(response => {
          const ac = response.data.data
          setData(prev => [ac, ...prev])
          setShowAsideModal(false)
        })
        .catch(() => {
          sweetAlert('Error', 'Failed to create account', 'error')
        })
    },
    delete() {
      axios
        .delete(`/api/accounts/${active.id}`)
        .then(() => {
          const edit = data.filter(a => a.id !== active.id)

          setData([...edit])
          setShowDeleteAccountModal(false)
        })
        .catch(() => {
          sweetAlert('Error', 'Failed to delete account', 'error')
        })
    },
  }

  return (
    <div className="users-table">

      <div className="filters-container">
        <div>
          &nbsp;
        </div>
        <div className="main-actions">
        <button className="action-main-buttons" onClick={handlers.addAccount}>
          Add new
        </button>
      </div>
      </div>

      <Modal show={showDeleteAccountModal} size="md" aria-labelledby="contained-modal-title-vcenter" centered>
        <Modal.Header>
          <div className="modal-title h4">Delete admin</div>
        </Modal.Header>
        <Modal.Body>
          <p> Are you sure you want to proceed?</p>
        </Modal.Body>
        <Modal.Footer>
          <button
            type="button"
            className="btn btn-default"
            onClick={() => {
              setShowDeleteAccountModal(false)
            }}
          >
            {' '}
            Cancel
          </button>
          <Button variant="info" onClick={handlers.delete}>
            Delete
          </Button>
        </Modal.Footer>
      </Modal>
      {showAsideModal && (
        <AsideModal visible={showAsideModal} size={'400px'} title={title} setVisible={setShowAsideModal}>
          <EditAccount
            intialFormValue={initialAccountFormValue}
            action={action}
            onSave={handlers.edit}
            onAdd={handlers.add}
          />
        </AsideModal>
      )}
      <DataTable
        className='new-table'
        columns={accountsHeader(handlers.editAccounts, handlers.deleteAccount)}
        data={data}
        pagination
      />
    </div>
  )
}

export default Accounts
